export default __webpack_public_path__ + "static/media/Cang Jei's Assorted Nasties.51cdcb52.jpg";